module.exports = __webpack_public_path__ + "static/media/wasd.e93f3a82.jpg";